/* By Color 导航：菜单项文字命中 9 个色系名时，在文字前加一个色块。
   见 color_PLAN.md。hex 与 filter_color/产品卡色块同一套。跨所有 header 布局 + 移动端抽屉，
   导航未配置时是无操作。 */
(function () {
  var NAV_COLORS = {
    white: "#FFFFFF", cream: "#F5EFE0", beige: "#E8DCC4", khaki: "#C3B091",
    grey: "#9098A0", gray: "#9098A0", brown: "#7A5230", black: "#1C1C1C",
    blue: "#3E6DA3", green: "#5C8A5A"
  };

  function decorate(root) {
    var scope = root || document;
    scope.querySelectorAll("header a, .menu-drawer a").forEach(function (a) {
      if (a.dataset.colorSwatched) return;
      var text = (a.textContent || "").trim().toLowerCase();
      var hex = NAV_COLORS[text];
      if (!hex) return;
      a.dataset.colorSwatched = "1";
      a.classList.add("nav-color-link");
      // 用 <i> 而非 <span>：主题对菜单内 span 有 `padding:1rem 0 !important`
      // (main-header.css .header__menu-item span)，会把方块撑成 18×20。<i> 不被命中。
      var sw = document.createElement("i");
      sw.className = "nav-color-swatch";
      sw.style.setProperty("--nav-swatch-color", hex);
      a.insertBefore(sw, a.firstChild);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { decorate(); });
  } else {
    decorate();
  }
  document.addEventListener("shopify:section:load", function (e) { decorate(e.target); });
  // 移动端抽屉的正文是点开汉堡时才从 <template> 搬进 DOM 的，
  // 页面加载时那一趟 decorate() 扫不到它。见 global.js 的 MenuDrawer.hydrateContent()。
  document.addEventListener("menu-drawer:hydrated", function (e) {
    decorate(e.detail && e.detail.drawer);
  });
})();
